<template>
  <div
    ref="session"
    v-images-loaded="onImagesLoaded"
    class="session session-3-viewpoints-invite-pathway"
    :class="{
      'session-inline': layoutType === SessionLayoutType.Inline,
      'session-wide': layoutType === SessionLayoutType.Wide,
      'loading': isLoading,
      'finished-inviting': hasFinishedInviting,
    }"
  >
    <div class="session-background session-background-viewpoints-invite">
      <!-- Include an image as well as the background to ensure the image is pre-loaded -->
      <img
        src="../../assets/sessions/backgrounds/viewpoints-pathways-background.png"
        alt="session background"
      />
    </div>

    <HomeNavigation ref="homeNavigation"></HomeNavigation>
    <TitleVisuals
      ref="titleVisuals"
      session-title="Viewpoints"
      :session-logo-image-src="titleLogoSrc"
    />
    <div class="background-visuals">
      <absolute-visual ref="treeOuter">
        <div ref="treeInner" class="tree-inner" style="width: 44%; left: 28%; top: 19%">
          <tree-visual ref="treeVisual" class="something-else"></tree-visual>
        </div>
        <img
          src="../../assets/sessions/session-3/session-3-tree-text.png"
          style="width: 100%; left: 0; top: 0"
          alt=""
        />
        <img
          ref="curiosityArrowImage"
          src="../../assets/sessions/session-3/curiosity-arrow.png"
          style="width: 35%; left: 11%; top: 37%"
          alt=""
        />
        <img
          ref="anxietyArrowImage"
          src="../../assets/sessions/session-3/anxiety-arrow.png"
          style="width: 21%; left: 68%; top: 18%"
          alt=""
        />
      </absolute-visual>
      <div ref="treeTextVisual" class="visual side-visual"></div>

      <absolute-visual ref="downlightVisual">
        <img
          ref="downlightImage"
          src="../../assets/sessions/session-3/downlight.png"
          style="width: 40%; left: 30%; bottom: 23%"
          alt=""
        />
      </absolute-visual>

      <absolute-visual ref="treeWithOutlineVisual">
        <img
          src="../../assets/sessions/session-3/tree-with-outline.png"
          style="width: 50%; left: 24%; bottom: 23%"
          alt=""
        />
      </absolute-visual>

      <absolute-visual ref="initialAvatarVisual">
        <img
          ref="initialAvatarImage"
          src="../../assets/sessions/session-3/avatar-with-shadow.png"
          alt="Gyre Avatar"
          style="width: 4%; left: 40%; top: 63%"
        />
      </absolute-visual>

      <absolute-visual ref="telescopeVisual">
        <img
          ref="telescopeImage"
          src="../../assets/sessions/session-3/telescope.png"
          style="width: 18%; left: 20%; top: 52%"
          alt=""
        />
      </absolute-visual>
      <absolute-visual ref="treeInTelescopeVisual">
        <div
          ref="whiteOvalWrapper"
          style="
            width: 40%;
            height: 40%;
            left: 50%;
            top: 18%;
            background-color: white;
            border-radius: 50%;
            border: 2px solid rgba(0, 0, 0, 0.7);
          "
        >
          <img
            ref="treeInTelescopeImage"
            src="../../assets/sessions/session-3/tree-in-telescope.png"
            style="position: absolute; width: 100%"
            alt=""
          />
          <img
            ref="reflectionImage"
            src="../../assets/sessions/session-3/reflection.png"
            style="position: absolute; width: 100%; height: 100%; left: 0; bottom: 0; opacity: 0"
            alt=""
          />
          <img
            ref="viewpointsSpeechBubbleImage"
            src="../../assets/sessions/session-3/viewpoints-speech-bubble.png"
            style="position: absolute; width: 90%; height: 90%; left: 5%; bottom: 5%; opacity: 0"
            alt=""
          />
          <div ref="speechBubbleNotch" class="speech-bubble-notch"></div>
        </div>
      </absolute-visual>

      <absolute-visual ref="speechBubbleAvatarVisual">
        <img
          ref="speechBubbleAvatarImage"
          src="../../assets/sessions/session-3/avatar-white-with-shadow.png"
          style="width: 6%; left: 58%; top: 55%"
          alt=""
        />
      </absolute-visual>

      <absolute-visual ref="crowdVisual">
        <img
          ref="crowdOneImage"
          src="../../assets/sessions/session-3/avatar-white.png"
          style="width: 3%; right: -10%; top: 65%"
          alt=""
        />
        <img
          ref="crowdTwoImage"
          src="../../assets/sessions/session-3/avatar-white.png"
          style="width: 3%; right: -10%; top: 68%"
          alt=""
        />
        <img
          ref="crowdThreeImage"
          src="../../assets/sessions/session-3/avatar-white.png"
          style="width: 3%; right: -10%; top: 66%"
          alt=""
        />
      </absolute-visual>

      <div
        ref="forestTopBackgroundVisual"
        class="visual forest-top-background-visual transitioned show"
      ></div>
      <div
        ref="forestBottomBackgroundVisual"
        class="visual forest-bottom-background-visual transitioned show"
      ></div>

      <div ref="darkBackgroundVisual" class="visual dark-background-visual">
        <div class="text-darken session-wide-only"></div>
      </div>
      <div ref="sampleReportVisual" class="visual side-visual visual-with-dark-drop-shadow">
        <img
          src="../../assets/sessions/viewpoints-report-sample.png"
          alt="Sample Viewpoints Report Cover"
          style="width: 60%; margin: 0 auto"
        />
      </div>

      <absolute-visual ref="whoVisual">
        <img
          ref="emptyViewpointsHeadImage"
          src="../../assets/sessions/session-3/empty-viewpoints-head.png"
          style="width: 16%; left: 40%; top: 42%"
          alt=""
        />
        <img
          ref="whoTextImage"
          src="../../assets/sessions/session-3/who-viewpoints-text.png"
          style="width: 65%; left: 20%; top: 25%"
          alt=""
        />
        <img
          ref="whoArrowFriends"
          src="../../assets/sessions/session-3/who-arrow.png"
          style="width: 25%; left: 12%; top: 29%"
          alt=""
        />
        <img
          ref="whoArrowFamily"
          src="../../assets/sessions/session-3/who-arrow.png"
          style="width: 25%; left: 45%; top: 11%; transform: rotateZ(90deg)"
          alt=""
        />
        <img
          ref="whoArrowCurrentColleagues"
          src="../../assets/sessions/session-3/who-arrow.png"
          style="width: 25%; left: 64%; top: 43%; transform: rotateZ(180deg)"
          alt=""
        />
        <img
          ref="whoArrowFormerColleagues"
          src="../../assets/sessions/session-3/who-arrow.png"
          style="width: 25%; left: 24%; top: 62%; transform: rotateZ(270deg)"
          alt=""
        />
      </absolute-visual>

      <absolute-visual ref="exemplarsVisual">
        <img
          ref="exemplarsInitialImage"
          src="../../assets/sessions/session-3/exemplar-viewpoints-1.png"
          style="width: 60%; left: 20%; top: 20%"
          alt=""
        />
        <img
          ref="exemplarsExtraImage"
          src="../../assets/sessions/session-3/exemplar-viewpoints-2.png"
          style="width: 23%; left: 38.5%; top: 8%; opacity: 0"
          alt=""
        />
        <img
          ref="exemplarsExtraCenterImage"
          src="../../assets/sessions/session-3/exemplar-viewpoints-3.png"
          style="width: 29.5%; left: 35.3%; top: 34.5%; opacity: 0"
          alt=""
        />
      </absolute-visual>
      <absolute-visual ref="shuttersVisual" :full-size="true">
        <div
          ref="leftShutter"
          class="left-shutter"
          style="top: 0; left: 0; width: 50%; height: 100%"
        ></div>
        <div
          ref="rightShutter"
          class="right-shutter"
          style="top: 0; left: 50%; width: 50%; height: 100%"
        ></div>
      </absolute-visual>
      <div ref="nextStepVisual" class="visual side-visual">
        <img
          src="../../assets/sessions/steps.png"
          alt="Sample Viewpoints Report Cover"
          style="width: 80%; margin: 0 auto"
        />
      </div>
    </div>
    <div ref="textWrapper" class="text-wrapper">
      <div id="slide0" class="slide-wrapper spacer-slide">
        <!-- Empty space for title display -->
      </div>
      <SessionSlide id="expectations">
        <template #text>
          <p>
            Your Solo report depicts how you see yourself.<br />
            But do others see you in the same way? Why not find out by doing your Gyre Viewpoints?
          </p>
          <p>It’s a quick and easy process!</p>
        </template>
      </SessionSlide>

      <SessionSlide id="philosophy" class="dark-slide">
        <template #text>
          <h2>Our Viewpoints Philosophy</h2>
          <p>
            As human beings we have two instincts that are often in tension with each other. On the
            one hand, we are curious to know how others see us, yet on the other hand, we tend to be
            anxious about other people evaluating us negatively. The net effect is that feedback can
            be hard to come by, yet it is like oxygen for development.
          </p>
          <p>
            In creating Gyre Viewpoints we want to build your curiosity and minimise your anxiety.
          </p>
        </template>
      </SessionSlide>

      <SessionSlide id="points-of-view" class="dark-slide">
        <template #text>
          <h3>Points of view</h3>
          <p>
            We chose the title Viewpoints carefully because we want to reflect the fact that we are
            all curious to know how others see us, and whether they see the same person in us as we
            see in ourselves. It is about their point of view on you: it is neither right nor wrong,
            and typically will tell you as much about them as it will about you.
          </p>
        </template>
      </SessionSlide>

      <SessionSlide id="strength-based" class="dark-slide">
        <template #text>
          <h3>Strength-based</h3>
          <p>
            Many people have experienced ‘360 feedback’ and found it to be an unhelpful experience.
            It often leaves people feeling evaluated and becomes about fault-finding.
          </p>
          <p>
            The way Viewpoints scores are calculated means that everyone (whether experienced CEO or
            current student) will have 5 most characteristic strengths and 5 least characteristic
            strengths in their report.
          </p>
          <p>
            It is about how people see the pattern of your strengths, not whether they think you are
            better or worse than another person.
          </p>
        </template>
      </SessionSlide>

      <SessionSlide id="not-anonymous" class="dark-slide">
        <template #text>
          <h3>Not anonymous</h3>
          <p>
            Other 360 processes are typically anonymous, with the belief that it will be more
            “truthful”. However, if website and social media comments are anything to go by,
            anonymity is often unhelpful. It gets in the way of people having conversations.
          </p>
          <p>
            In Viewpoints the headline view from each of your respondents is attributable. You will
            get to see how each of them see your 2 best-fit and 2 least-fit Leader types.
          </p>
          <p>
            We also make it easy for your respondents to share their full report with you so that
            you both can have a rich conversation picking through the detail of how they see your
            strengths and leadership.
          </p>
          <p>
            Viewpoints combines the positives of truthful, attributable feedback on your relative
            strengths and gaps without the crushing negatives of harmful comments or league table
            popularity polls.
          </p>
        </template>
      </SessionSlide>

      <SessionSlide id="anxious" class="dark-slide">
        <template #text>
          <h3>People can be as anxious giving feedback as receiving it</h3>

          <p>
            We have also thought hard about creating a really positive experience for people
            offering their point of view to you.
          </p>
          <p>
            Comments from our users giving their Viewpoints feedback are that they find the
            experience engaging and thought-provoking, often helping them see the individual in a
            new light.
          </p>
        </template>
      </SessionSlide>

      <SessionSlide id="sample-report">
        <template #text>
          <p>
            If you want to get an idea of what your Viewpoints report will look like, use this link
            to see a sample report:
          </p>
          <p class="text-center">
            <a
              :href="sampleViewpointsReportUrl"
              class="btn btn-primary btn-lg"
              target="_blank"
              rel="noopener noreferrer"
            >
              View sample report
            </a>
          </p>
        </template>
      </SessionSlide>

      <SessionSlide id="who-to-ask">
        <template #text>
          <h2>Who to turn to for feedback</h2>
          <p>
            Turn to people whose opinion and views you value. They can be current colleagues, your
            boss, former colleagues, partners. But also think about family and friends.
          </p>
          <p>
            The aim is to understand how people see you and what is at the core of your character.
            Don’t be surprised if different people or groups of people see you in different ways!
          </p>
        </template>
      </SessionSlide>

      <SessionSlide id="how-many">
        <template #text>
          <p>
            Invite more people rather than fewer. If you get just 3 or 4 Viewpoints, the patterns
            can be hard to see, particularly if you have got feedback from different parts of your
            life, personal and professional.
          </p>
          <p>
            Typically, you will want at least 6 responses, so anticipate connecting with 10 or more
            people to invite their involvement.
          </p>
          <p>
            Once you have made your invitations, Gyre will help you keep track of who has responded.
            It’s very straightforward to send a reminder to anyone who forgot to complete. Gyre will
            automatically update your report as you get more data.
          </p>
        </template>
      </SessionSlide>

      <SessionSlide id="remains-live">
        <template #text>
          <p>
            Unlike traditional 360 feedback systems, your Viewpoints functionality remains ‘live’
            for as long as you have full membership.
          </p>
          <p>
            This means you can add further respondents at any point and there is no upper limit to
            how many people you can invite. It also means that you can return and repeat Viewpoints
            at any stage through your membership.
          </p>
        </template>
      </SessionSlide>

      <SessionSlide id="invite">
        <template #text>
          <h2>Invite</h2>
          <p>
            Type in the names or email addresses of people you want feedback from. If they are
            already registered, their email address will automatically fill out.
          </p>
          <p>
            You can always invite more later from your
            <a href="/home?view=MyDashboard" target="_blank">My Dashboard page</a>.
          </p>
          <div ref="inviteControlWrapper" class="visual side-visual invite-wrapper">
            <invite-control
              :model="inviteControlModel"
              :show-examples="true"
              @invite-action="onInviteAction"
            ></invite-control>
          </div>
        </template>
      </SessionSlide>

      <SessionSlide id="next-steps" class="last-slide">
        <template #text>
          <h3>Next steps</h3>
          <p></p>
          <p>
            As your respondents complete their feedback for you, you’ll receive notifications from
            us, so you know when to log back in.
          </p>
          <p>
            You’ll need to wait until you have at least two viewpoints responses before you can
            access your Viewpoints report.
          </p>
          <p>
            Once your Viewpoints report is ready, we advise you complete the ‘Working with Your
            Viewpoints Report’ pathway as this will guide you through the key insights to be gained
            from your report.
          </p>
          <p>Until then!</p>
          <div class="cta-button-wrapper">
            <a
              class="btn btn-lg btn-primary journey-next-step"
              @click="closeSession"
              @keydown.enter="closeSession"
              data-test="complete-viewpoints-pathway"
              >Close session</a
            >
          </div>
        </template>
      </SessionSlide>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ComponentPublicInstance, getCurrentInstance, onMounted, onUnmounted, ref } from "vue";
import { Power0, Power2, Power4, Back, TimelineMax, TweenLite } from "gsap";
import * as ScrollMagic from "scrollmagic";
import Debug from "debug";
import imagesLoadedDirective from "../../directives/images-loaded";

import { InviteControlApiModel, SessionsApiModel } from "../../api-models";
import SessionWrapper from "../../components/sessions/session-wrapper.vue";
import SessionSlide from "../../components/sessions/session-slide.vue";
import { SessionLayoutType } from "../../components/sessions/session-animation-controller";
import HomeNavigation from "../../components/sessions/home-navigation.vue";
import TitleVisuals from "../../components/sessions/title-visuals.vue";
import InviteControl from "../../components/invite-control/invite-control.vue";
import TreeVisual from "../../components/sessions/tree-visual.vue";
import AbsoluteVisual from "../../components/sessions/absolute-visual.vue";
import { SessionIds } from "../../components/sessions/session-models";
import SessionInstanceState from "../../components/sessions/session-instance-state";
import useSessionBase from "../../composables/useSessionBase";
import useNotification, { CompletionNotification } from "../../composables/useNotification";
import { csContext } from "../../services/cs-context";
import viewpointsSessionLinkResourceIds from "../../services/cms/viewpoints-session-link-resource-ids";

const debug = Debug("cs.Session3ViewpointsInvite");

const props = defineProps<{
  sessionsModel: SessionsApiModel;
  inviteControlModel: InviteControlApiModel;
}>();

const vImagesLoaded = imagesLoadedDirective;

// eslint-disable-next-line @typescript-eslint/no-var-requires
const titleLogoSrc = ref(require("../../assets/sessions/jyranians-facing.png"));

const sampleViewpointsReportUrl =
  "https://app.gyreteams.com/sharedreport/J7FjaaBFwb7TIpv/viewpoints-report-for-vicky-hope";

const hasFinishedInviting = ref<boolean>(
  SessionInstanceState.withStore("hasFinishedInviting", false),
);

function getSessionId(): string {
  return SessionIds.ViewpointsInvite;
}

const instance = getCurrentInstance()?.proxy as ComponentPublicInstance;

const {
  isInline,
  hasCompletedSession,
  initializeAfterImagesLoaded,
  initialize,
  initializeAnimations,
  isLoading,
  handleCloseSession,
  handleKeyDown,
  layoutType,
  titleTimescale,
  loadAnimations,
  scene,
  element,
  classScene,
  destroyed,
  getSessionVersion,
  animations,
} = useSessionBase(getSessionId, instance);

function unlockNextSteps(): void {
  hasFinishedInviting.value = true;
  TweenLite.set(element("#next-steps"), { "max-height": "unset" });
}

function onKeyDown(event: KeyboardEvent): void {
  handleKeyDown(event);
}

onUnmounted(() => {
  document.removeEventListener("keydown", onKeyDown);
  SessionInstanceState.set("hasFinishedInviting", hasFinishedInviting.value);
  destroyed();
});

function closeSession(): void {
  handleCloseSession();
}

function onImagesLoaded(): void {
  initializeAfterImagesLoaded();
}

function onInviteAction(): void {
  if (!hasFinishedInviting.value) {
    unlockNextSteps();
  }
}

// Visual element refs
const homeNavigation = ref();
const titleVisuals = ref();
const darkBackgroundVisual = ref();
const forestTopBackgroundVisual = ref();
const forestBottomBackgroundVisual = ref();
const treeOuter = ref();
const curiosityArrowImage = ref();
const anxietyArrowImage = ref();
const treeTextVisual = ref();
const initialAvatarVisual = ref();
const initialAvatarImage = ref();
const treeInner = ref();
const telescopeImage = ref();
const telescopeVisual = ref();
const treeInTelescopeVisual = ref();
const whiteOvalWrapper = ref();
const treeInTelescopeImage = ref();
const reflectionImage = ref();
const viewpointsSpeechBubbleImage = ref();
const speechBubbleAvatarVisual = ref();
const speechBubbleNotch = ref();
const crowdVisual = ref();
const crowdOneImage = ref();
const crowdTwoImage = ref();
const crowdThreeImage = ref();
const downlightVisual = ref();
const downlightImage = ref();
const treeWithOutlineVisual = ref();
const sampleReportVisual = ref();
const whoVisual = ref();
const emptyViewpointsHeadImage = ref();
const whoArrowFriends = ref();
const whoArrowFamily = ref();
const whoArrowCurrentColleagues = ref();
const whoArrowFormerColleagues = ref();
const exemplarsVisual = ref();
const exemplarsExtraImage = ref();
const exemplarsExtraCenterImage = ref();
const leftShutter = ref();
const rightShutter = ref();
const inviteControlWrapper = ref();
const shuttersVisual = ref();
const nextStepVisual = ref();

loadAnimations.value = () => {
  const defaultTriggerPosition = isInline.value ? 1 : 0.3;
  const postDarkTriggerPosition = isInline.value ? defaultTriggerPosition : 0.5;
  const defaultEase = Power2.easeInOut;
  TweenLite.defaultEase = defaultEase;

  const timescale = 0.5;
  document.addEventListener("keydown", onKeyDown);
  // document.addEventListener("wheel", this.onWheel);

  const titleTriggerHookPosition = isInline.value ? 0.98 : 1;

  const titleVisualEase = isInline.value ? Power0.easeNone : Power2.easeOut; // Fade out linearly (with scroll position) when inline
  const titleTextEase = isInline.value ? Power4.easeOut : Power4.easeOut; // Fade out quickly when inline to avoid overlaying

  const titleTimeline = () => {
    const tl = new TimelineMax({ paused: true });

    (homeNavigation.value as any).colorSwitch(tl);
    (titleVisuals.value as InstanceType<typeof TitleVisuals>).rollIn(tl, false);

    tl.to(
      element("expectations"),
      titleTimescale * 0.3,
      { autoAlpha: 1, ease: titleVisualEase },
      0,
    );

    return tl;
  };

  // Pre-hide light/dark transition SessionSlides
  TweenLite.set(element("#philosophy"), { autoAlpha: 0.3 });
  TweenLite.set(element("#next-steps"), { autoAlpha: 0.3 });

  const titleScene = new ScrollMagic.Scene({
    triggerElement: element("expectations-inner"),
    triggerHook: titleTriggerHookPosition,
  });

  animations.value!.linkAnimationToScene(
    "title",
    titleTimeline,
    titleScene,
    undefined,
    element("expectations"),
  );

  scene("#philosophy", (tl) => {
    tl.to(darkBackgroundVisual.value, timescale, { autoAlpha: 1 }, 0);
    tl.fromTo(forestTopBackgroundVisual.value, timescale, { left: "-100%" }, { left: "0%" }, 0);
    tl.fromTo(forestBottomBackgroundVisual.value, timescale, { left: "100%" }, { left: "0%" }, 0);
    tl.to(element("#expectations"), timescale, { autoAlpha: 0.1 }, 0);
    (titleVisuals.value as InstanceType<typeof TitleVisuals>).sessionLogoRotateOut(tl);
    (homeNavigation.value as any).colorRevert(tl);
    tl.to(
      (treeOuter.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale,
      { autoAlpha: 1 },
      0,
    );
    tl.fromTo(curiosityArrowImage.value, timescale, { rotation: -120 }, { rotation: 0 }, 0);
    tl.fromTo(anxietyArrowImage.value, timescale, { rotation: -120 }, { rotation: 0 }, 0);
    tl.to(treeTextVisual.value, timescale, { autoAlpha: 1 }, 0);
    tl.to(
      (initialAvatarVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale,
      { autoAlpha: 1 },
      0,
    );
    tl.to(element("#philosophy"), timescale / 2, { autoAlpha: 1 }, 0);
    tl.to(element("#sample-report"), 0, { autoAlpha: 0 }, 0); // Pre-hide the post-dark slide
  });

  scene("#points-of-view", (tl) => {
    tl.to(
      (treeOuter.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale,
      { autoAlpha: 0 },
      0,
    );
    tl.to(initialAvatarImage.value, timescale, { left: "15%", scale: 1.7 }, 0);
    tl.to(treeInner.value, timescale, { x: "+20%", y: "-20%", scale: 0.6, autoAlpha: 0 }, 0);
    tl.fromTo(telescopeImage.value, timescale, { top: "100%" }, { top: "52%" }, 0);
    tl.to(
      (telescopeVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale,
      { autoAlpha: 1 },
      0,
    );
    tl.fromTo(
      (treeInTelescopeVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale,
      { scale: 0.5, autoAlpha: 0 },
      { scale: 1, autoAlpha: 1 },
      0,
    );
  });

  scene("#strength-based", (tl) => {
    tl.to(
      (telescopeVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale * 2,
      { autoAlpha: 0 },
      0,
    );
    tl.to(initialAvatarImage.value, timescale * 2, { left: "28%", scale: 2.1 }, 0);
    tl.to(
      whiteOvalWrapper.value,
      timescale * 2,
      {
        left: "30%",
        top: "35%",
        scaleX: 0.55,
        borderColor: "orange",
        borderWidth: 5,
      },
      0,
    );
    tl.to(treeInTelescopeImage.value, timescale * 2, { autoAlpha: 0 }, 0);
    tl.to(reflectionImage.value, timescale * 2, { autoAlpha: 1 }, 0);
  });

  scene("#not-anonymous", (tl) => {
    tl.to(
      whiteOvalWrapper.value,
      timescale * 2,
      { left: "30%", top: "25%", scaleX: 0.5, scaleY: 0.5, borderWidth: 0 },
      0,
    );
    tl.to(reflectionImage.value, timescale, { autoAlpha: 0 }, 0);
    tl.to(viewpointsSpeechBubbleImage.value, timescale, { autoAlpha: 1 }, timescale);
    tl.to(
      (speechBubbleAvatarVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale,
      { autoAlpha: 1 },
      timescale,
    );
    tl.to(speechBubbleNotch.value, timescale * 2, { autoAlpha: 1, bottom: "5%", right: "12%" }, 0);
  });

  scene("#anxious", (tl) => {
    tl.to(
      (treeInTelescopeVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale,
      { autoAlpha: 0 },
      0,
    );
    tl.to(whiteOvalWrapper.value, timescale, { autoAlpha: 0 }, 0);
    tl.to(
      (speechBubbleAvatarVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale,
      { autoAlpha: 0 },
      0,
    );
    tl.to((crowdVisual.value as InstanceType<typeof AbsoluteVisual>).$el, 0.1, { autoAlpha: 1 }, 0);
    tl.to(crowdOneImage.value, timescale, { right: "20%", ease: Back.easeOut }, 0);
    tl.to(crowdTwoImage.value, timescale, { right: "10%", ease: Back.easeOut }, timescale * 0.1);
    tl.to(crowdThreeImage.value, timescale, { right: "6%", ease: Back.easeOut }, timescale * 0.15);
    tl.to(
      (downlightVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale,
      { autoAlpha: 1 },
      0,
    );
    tl.fromTo(downlightImage.value, timescale, { bottom: "100%" }, { bottom: "23%" }, 0);
    tl.to(
      (treeWithOutlineVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale / 2,
      { autoAlpha: 1 },
      timescale / 2,
    );
    tl.to(initialAvatarImage.value, timescale, { left: "40%", scale: 0.9 }, 0);
  });

  scene("#sample-report", (tl) => {
    tl.to((crowdVisual.value as InstanceType<typeof AbsoluteVisual>).$el, 0.1, { autoAlpha: 0 }, 0);
    tl.to(
      (initialAvatarVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      0.1,
      { autoAlpha: 0 },
      0,
    );
    tl.to(
      (downlightVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      0.1,
      { autoAlpha: 0 },
      0,
    );
    tl.to(
      (treeWithOutlineVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      0.1,
      { autoAlpha: 0 },
      0,
    );
    tl.fromTo(
      sampleReportVisual.value,
      timescale,
      { autoAlpha: 0, scale: 0.8 },
      { autoAlpha: 1, scale: 1 },
      0,
    );
    tl.to(forestTopBackgroundVisual.value, timescale, { left: "-100%" }, 0);
    tl.to(forestBottomBackgroundVisual.value, timescale, { left: "100%" }, 0);
    tl.to(darkBackgroundVisual.value, timescale, { autoAlpha: 0 }, 0);
    (homeNavigation.value as any).colorSwitch(tl);
    tl.to(element("#anxious"), timescale / 2, { autoAlpha: 0.1 }, 0);
    tl.to(element("#sample-report"), timescale / 2, { autoAlpha: 1 }, 0);
  });

  scene("#who-to-ask", (tl) => {
    tl.to(sampleReportVisual.value, timescale, { autoAlpha: 0, scale: 0.8 }, 0);
    tl.to(
      (whoVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale,
      { autoAlpha: 1 },
      0,
    );
    tl.fromTo(emptyViewpointsHeadImage.value, timescale, { left: "42%" }, { left: "40%" }, 0);
    tl.fromTo(whoArrowFriends.value, timescale, { rotation: -180 }, { rotation: 0 }, 0);
    tl.fromTo(whoArrowFamily.value, timescale, { rotation: -90 }, { rotation: 90 }, 0);
    tl.fromTo(whoArrowCurrentColleagues.value, timescale, { rotation: 0 }, { rotation: 180 }, 0);
    tl.fromTo(whoArrowFormerColleagues.value, timescale, { rotation: 90 }, { rotation: 270 }, 0);
  });

  scene("#how-many", (tl) => {
    tl.to(
      (whoVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale,
      { autoAlpha: 0 },
      0,
    );
    tl.to(whoArrowFriends.value, timescale, { rotation: 180 }, 0);
    tl.to(whoArrowFamily.value, timescale, { rotation: 270 }, 0);
    tl.to(whoArrowCurrentColleagues.value, timescale, { rotation: 360 }, 0);
    tl.to(whoArrowFormerColleagues.value, timescale, { rotation: 420 }, 0);
    tl.to(
      (exemplarsVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale,
      { autoAlpha: 1 },
      0,
    );
  });

  scene("#remains-live", (tl) => {
    tl.to(exemplarsExtraImage.value, timescale * 2, { autoAlpha: 1 }, 0);
    tl.to(exemplarsExtraCenterImage.value, timescale * 2, { autoAlpha: 1 }, 0);
  });

  scene("#invite", (tl) => {
    tl.to(
      (exemplarsVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale,
      { autoAlpha: 0 },
      0,
    );
    tl.to(
      (shuttersVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      0.1,
      { autoAlpha: 1 },
      0,
    );
    tl.fromTo(leftShutter.value, timescale * 1.5, { left: "-50%" }, { left: "0" }, 0);
    tl.fromTo(rightShutter.value, timescale * 1.5, { left: "100%" }, { left: "50%" }, 0);
    tl.to(
      inviteControlWrapper.value,
      timescale,
      { autoAlpha: 1, className: "+=clickable" },
      timescale * 1.5,
    );
  });

  scene("#next-steps", (tl) => {
    tl.to(
      (shuttersVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale,
      { autoAlpha: 0 },
      0,
    );
    tl.to(inviteControlWrapper.value, timescale / 2, { autoAlpha: 0, className: "-=clickable" }, 0);
    tl.fromTo(
      nextStepVisual.value,
      timescale,
      { autoAlpha: 0, scale: 0.8 },
      { autoAlpha: 1, scale: 1 },
      0,
    );
    tl.to(element("#next-steps"), timescale / 2, { autoAlpha: 1 }, 0);
  });
};

// TODO: review, is this correct? Is this a general notification or a completed notification that
// needs to be triggered upon an action?
// TODO: speak to Victoria about when to trigger this.
function triggerNotification(): void {
  const { createCompletionNotification } = useNotification();

  const teamId = csContext.currentTeam?.id;

  if (!teamId) {
    return;
  }

  const notification: CompletionNotification = {
    userId: csContext.user.id,
    teamId,
    prismicDoc: null,
    linkResourceId: viewpointsSessionLinkResourceIds.viewpointsInvite,
    linkResourceName: "Viewpoints invite",
  };

  createCompletionNotification(notification);
}

onMounted(() => {
  initialize(props.sessionsModel);
  if (
    props.inviteControlModel.userTags.length > 0 ||
    hasCompletedSession.value ||
    hasFinishedInviting.value
  ) {
    unlockNextSteps();
  }

  initializeAnimations();
  // triggerNotification();
});

defineExpose({
  isLoading,
  getSessionId,
  getSessionVersion,
  classScene,
  isInline,
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import "../../styles/sessions/session-variables.less";
@import "../../styles/sessions/session-layout-mixins.less";

.session-3-viewpoints-invite-pathway {
  .session-background-viewpoints-invite {
    background-image: url(../../assets/sessions/backgrounds/viewpoints-pathways-background.png);
  }

  .initial-logo-visual img {
    margin: 0;
  }

  .slide-inner {
    width: 100%;
  }

  .SessionSlide-no-bottom-margin.SessionSlide-no-bottom-margin.SessionSlide-no-bottom-margin {
    margin-bottom: 20px;
  }

  .z-index-override-0 {
    z-index: 6 !important;
  }

  .z-index-override-1 {
    z-index: 7 !important;
  }

  .slide-wrapper {
    transition: background-color 1s;
  }

  .session {
    transition: background-color 1s;
  }

  .session .initial-logo-for-positioning .img-wrapper img {
    margin: 0 auto;
  }

  //.visual.side-visual > * {
  //  max-width: 400px;
  //}

  .visual-with-dark-drop-shadow {
    filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.3));
  }

  &:not(.finished-inviting) .slide-after-activity {
    max-height: 0;
    overflow: hidden;
  }

  &.session-inline .last-slide {
    margin-bottom: 0vh;
  }

  .forest-top-background-visual {
    top: 0;
    left: -100%;
    width: 100%;
    height: 70%;
    background-color: rgb(65, 65, 74);
    z-index: -1; // In the background (behind text + other visuals)
  }

  .forest-bottom-background-visual {
    top: 70%;
    left: 100%;
    height: 100%;
    width: 100%;
    background-color: rgb(44, 44, 54);
    z-index: -1; // In the background (behind text + other visuals)
  }

  &.session-inline {
    .forest-top-background-visual {
      height: 50%;
    }

    .forest-bottom-background-visual {
      top: 50%;
    }
  }

  .dark-background-visual {
    // background-color: @dark-background-color;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;

    .text-darken::after {
      position: fixed;
      left: 0;
      top: 0;
      bottom: 0;
      right: 50%;
      background: linear-gradient(to right, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
      content: " ";
    }
  }

  .speech-bubble-notch {
    position: absolute;
    bottom: 50%;
    right: 50%;
    background-color: white;
    min-width: 20%;
    min-height: 20%;
    z-index: -1;
    opacity: 0;
  }

  .invite-wrapper {
    pointer-events: none;
    width: 60%;
    margin: 0px auto;
  }

  .left-shutter {
    background-color: #f5f4f5;
  }

  .right-shutter {
    background-color: white;
  }

  &.session-inline {
    .invite-wrapper {
      position: static;
      width: 100vw;
      margin: 40px 0;
      height: auto;
      padding: 20px;
      background-color: white;
      filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.3));
      max-width: 100% !important;

      .invite-control {
        max-width: 100% !important;
        max-height: unset !important;
      }
    }

    .left-shutter {
      background-color: white;
    }
  }

  &.session-inline:not(.finished-inviting) {
    //.invite-wr
    #invite .slide-wrapper {
      margin-bottom: 25vh;
    }

    #next-steps {
      margin: 0;
      top: 200%; // This prevents the transition from firing
    }
  }

  .invite-control {
    max-width: 60% !important;
    max-height: 70vh;
  }

  &.session-inline,
  .clickable {
    .invite-control,
    a {
      pointer-events: all;
    }
  }
}
</style>
